module.exports = __webpack_public_path__ + "images/users/form/group-2_6dd428cdaaf9885e0f3dcb03191d993c.svg";